import React, { useEffect, useState } from "react";
import Loader from "../../../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../../../helper/notification-messages";
import { clinicService } from "../../../../services/clinicService";
import { useLocation } from "react-router";
import DatePickerKendoRct from "../../../../control-components/date-picker/date-picker";
import CustomSkeleton from "../../../../control-components/skeleton/skeleton";
import { ListView, ListViewHeader } from "@progress/kendo-react-listview";
import moment from "moment";

function ClinicTextSetup() {
  const { state } = useLocation();
  const regionData = state?.field?.regionId;
  const masterClinicId = state?.field?.id;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [textReminderInfo, setTextReminderInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTextReminderCount();
  }, [startDate, endDate])

  const getTextReminderCount = async () => {
    setLoading(true);
    const dateStart = moment(startDate).startOf("day").format('YYYY-MM-DD')
    const dateEnd = moment(endDate).startOf("day").format('YYYY-MM-DD')
    await clinicService
      .GetClinicSmsUsage(masterClinicId, dateStart, dateEnd)
      .then((result) => {
        if (result.status) {
          setTextReminderInfo([{ textReminderCount: result.resultData }])
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };

  const ConsumptionsViewHeader = () => {
    return (
      <ListViewHeader className="listview-header">
        <div className="row border-bottom align-middle m-0 py-2">
          <div className="col">
            <h6 className="f-14">Service</h6>
          </div>
          <div className="col">
            <h6 className="f-14">Consumption</h6>
          </div>
        </div>
      </ListViewHeader>
    );
  };

  const ConsumptionsViewRender = (props) => {
    let item = props.dataItem;
    return (
      <>
        {textReminderInfo?.length > 0 ? (
          <div className="row py-2 border-bottom align-middle listview-row m-0">
            <div className="col">
              {loading ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>
                  Text Reminders
                </div>
              )}
            </div>
            <div className="col">
              {loading ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>{item.textReminderCount}</div>
              )}
            </div>
          </div>
        ) : (
          "No Data Found"
        )}
      </>
    );
  };


  return (
    <>
        <div style = {{minHeight: '200px'}} className="bg-white p-3">
          <div className="clinic-template-header pb-2">
            <div className="clinic-template-header-content">
              <h5 className="clinic-template-title">Consumptions</h5>
              <div className="clinic-template-dropdown date-field">
              <DatePickerKendoRct
                  value={startDate ? new Date(startDate) : new Date()}
                  onChange={(e) => {
                    setStartDate(e.value);
                  }}                  
                  label={"Start Date"}
              />
              </div>
              <div className="clinic-template-dropdown date-field pl-3">
              <DatePickerKendoRct
                  value={endDate ? new Date(endDate) : new Date()}
                  onChange={(e) => {
                    setEndDate(e.value);
                  }}                  
                  label={"End Date"}
              />
              </div>
            </div>
          </div>
          {textReminderInfo.length > 0 ? (
            <ListView
              data={textReminderInfo}
              item={ConsumptionsViewRender}
              className="listview-container"
              header={ConsumptionsViewHeader}
            />
            ) : (
            <div className="no-data-container">No data found</div>
          )}
         </div>
    </>  
  )
}
export default ClinicTextSetup